<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="mt-header-nav">
      <DataList :api="api" :params="params">
        <template v-slot:item="item">
          <div class="doctor-item" @click="toInfo(item.obj)">
            <doctor-card
              :data="item.obj"
              :enabledDisplayDutyTitle="enabledDisplayDutyTitle"
            />
          </div>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import DoctorCard from "@/components/DoctorCard";

export default {
  components: {
    DataList,
    DoctorCard,
  },
  data() {
    return {
      title: "医生介绍",
      api: "Doctor_List",
      params: {},
      enabledDisplayDutyTitle: false,
    };
  },
  created() {
    let queryParams = this.$route.query;
    let DepartmentId = queryParams.DepartmentId ? queryParams.DepartmentId : 0;
    let IsRecommend = queryParams.IsRecommend == 1;

    this.params.DepartmentId = DepartmentId;
    if (DepartmentId) {
      this.api = "Doctor_GetDoctorPageByDepartmentId";
    } else if (IsRecommend) {
      this.title = "专家介绍";
      this.api = "Doctor_GetRecommendPage";
    }

    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      this.enabledDisplayDutyTitle = res.data.enabledDisplayDutyTitle;
    });
  },
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "hospitalDoctorInfo",
        query: {
          Id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
